export const initialValues = {
  name: '',
  company: undefined,
  social_name: '',
  cnpj: '',
  description: '',
  contract: '',
  email: '',
  cell_phone: '',
  address: {
    code_post: '',
    street: '',
    number: '',
    district: '',
    complement: '',
    city: {
      id: '',
      name: '',
      state: {
        id: '',
        name: '',
      },
    },
  },
};
